
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AttributeMasterGrid extends Serenity.EntityGrid<AttributeMasterRow, any> {
        protected getColumnsKey() { return 'OMS.AttributeMaster'; }
        protected getDialogType() { return AttributeMasterDialog; }
        protected getIdProperty() { return AttributeMasterRow.idProperty; }
        protected getLocalTextPrefix() { return AttributeMasterRow.localTextPrefix; }
        protected getService() { return AttributeMasterService.baseUrl; }
        protected getInsertPermission() { return AttributeMasterRow.insertPermission; }
        protected getUpdatePermission() { return AttributeMasterRow.updatePermission; }
        protected getDeletePermission() { return AttributeMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            return grid;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}